import './BaseViewOverview.scss';

import BaseViewOverview from './BaseViewOverview';

export default BaseViewOverview;
